import { Icon } from 'core-ui';
import { GoBackSvg } from './svg';

const GoBackIcon = () => <Icon component={GoBackSvg} />;

export default GoBackIcon;
